module.exports = __webpack_public_path__ + "assets/485e58e3781f4b9ed85de2fe658ff7f7.png";